import { type ComponentProps } from 'react';

import { cn } from '@apps/web/lib/utils';

export function InboxListRow({
    picked = false,
    active = false,
    className,
    ...props
}: ComponentProps<'div'> & {
    readonly picked?: boolean;
    readonly active?: boolean;
}) {
    return (
        <div
            {...props}
            className={cn(
                'flex min-h-[58px] items-center gap-2.5 rounded-lg border border-transparent py-2 pr-2.5 pl-2.5 transition-colors duration-300 ease-out',
                picked
                    ? 'bg-primary/5'
                    : active
                      ? 'bg-accent'
                      : 'hover:bg-muted/40',
                className,
            )}
        />
    );
}
